import React, { useContext } from 'react';
import { useEffect} from 'react';
import AppContext from '../hooks/AppContext'

const ErrorPage= (props) =>{

    const {setLoading} = useContext(AppContext);
    useEffect(() => {     
        setLoading(false)
    },[]);

    return ( 
        <div className="layout-main app-layout layout-error-page">
            <div className="layout-error-page-context">           
                <h1><i className="pi pi-code"></i> Oops! {props?.codigo || ""}</h1>
                <h1>{props?.mensagem || "Erro na aplicação"}</h1>
                {props?.detalhe &&
                    <span>{props?.detalhe || "detalhe importante"}</span>            
                }
            </div>
        </div>
        
    );
}
  
export default ErrorPage;